import { getIn } from 'admin-panel/resources/utils';

export interface ValidatedForm {
  errors?: object;
  touched?: object;
}

export const fieldErrors = (
  form: ValidatedForm,
  path: string
): string[] | undefined =>
  (form.errors as Record<string, string[] | undefined> | undefined)?.[path];

export const fieldTouched = (form: ValidatedForm, path: string): boolean =>
  Boolean(getIn(form.touched, path));
